"use client"

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { ScrollArea } from "@/components/ui/scroll-area"

interface AboutModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AboutModal({ open, onOpenChange }: AboutModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl">Vnitřní mapa – nástroj pro vědomé fungování</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-full max-h-[calc(85vh-120px)] pr-4">
          <div className="space-y-6 text-sm leading-relaxed">
            <p className="text-muted-foreground text-pretty">
              Po jednom hlubokém terapeutickém rozhovoru jsem si uvědomil, že mám kolem sebe spoustu nástrojů na
              plánování, řízení a výkon — ale žádný jednoduchý nástroj, který by mi pomohl zorientovat se v sobě.
            </p>
            <p className="text-muted-foreground text-pretty">
              Nástroj, který mi každý den položí otázku tak, abych správně vyhodnotil, jak na tom jsem na škále od 1 do 10, kde si mohu k tomu napsat poznámku a hlavně sledovat trend v čase. Vše na dva kliky.
            </p>
            <p className="text-muted-foreground text-pretty">
              Během tří hodin jsem připravil front-end aplikace, který jsem si nejdříve rozpracoval s ChatGPT a pak díky "vibe-codingu" jej dodělal. Následně trvalo pár dní, než vznikl celý backend a plně funkční aplikace. Žádné složitosti, funguje na iOS i Androidu i na desktopu.
            </p>
            <p className="text-muted-foreground text-pretty">
              A tady je! Zdarma, pro mne, pro vás.
            </p>

            <div className="border-t pt-5">
              <h3 className="font-semibold text-base mb-2">Pro koho je</h3>
              <p className="text-muted-foreground text-pretty">
                Tento nástroj je určen pro manažery, podnikatele a lidi ve výkonu, kteří potřebují fungovat s hlavou a
                mít dostatek energie pro práci i osobní život. Pro ty, kdo chtějí zůstat výkonní, ale nevyhořet. Pomáhá jednoduše a vizuálně
                pojmenovat, v jaké zóně se právě nacházíš — a nabídne ti konkrétní, lidské doporučení, co dělat právě
                teď.
              </p>
              <p className="text-muted-foreground text-pretty mt-3">
                Pro lepší pochopení jsem přidal dvě metafory:
              </p>
            </div>

            <div className="border-t pt-5">
              <h3 className="font-semibold text-base mb-2">Metafora kytky – rytmus růstu</h3>
              <p className="text-muted-foreground text-pretty">
                Kytka roste, když má světlo, vodu a čas. Potřebuje cyklus růstu i odpočinku, jinak uvadne. Stejně tak i
                ty. Tahle metafora připomíná, že nejsme stroje, ale živé organismy. Růst má smysl jen tehdy, když se má
                kam zakořenit.
              </p>
            </div>

            <div className="border-t pt-5">
              <h3 className="font-semibold text-base mb-2">Metafora dálnice – tempo a riziko</h3>
              <p className="text-muted-foreground text-pretty">
                Na dálnici můžeš jet 130 km/h a cítit se plynule. Když zrychlíš na 170, neušetříš čas — jen neúměrně zvýšíš
                riziko nehody. Stejné je to i v životě a práci. Tahla metafora ti pomáhá vnímat rychlost, napětí a
                hranice, aby ses mohl(a) rozhodovat vědomě.
              </p>
            </div>

            <div className="border-t pt-5">
              <h3 className="font-semibold text-base mb-2">Důležitá zóna regenerace – tiché přistání</h3>
              <p className="text-muted-foreground text-pretty">
                Krom základních 10 zón tam přibyla 1 navíc. Ta je důležitá, jelikož když zpomalíš, tělo a mysl potřebují čas, aby se znovu sladily. Únava po výkonu není slabost, ale
                součást hojení. Regenerace není krok zpět — je to nádech před dalším růstem.
              </p>
            </div>

            <div className="border-t pt-5">
              <h3 className="font-semibold text-base mb-2">Proč tato aplikace vznikla</h3>
              <p className="text-muted-foreground text-pretty">
                Chtěl jsem mít nástroj, který není o datech, číslech a hodnocení, ale o vědomém zastavení. Nástroj,
                který pomáhá vidět, kde právě jsem, a umožňuje měnit tempo dřív, než přijde kolaps.
              </p>
              <p className="text-muted-foreground text-pretty">
                Tahle aplikace není terapie ani kouč. Je to kompas, který ti pomůže fungovat zdravěji – a vrátit do
                výkonu lehkost, přehled a rytmus.
              </p>
            </div>

            <div className="border-t pt-5 text-right">
              <p className="font-semibold">David Kašper</p>
              <p className="text-sm text-muted-foreground">tvůrce konceptu Vnitřní mapa</p>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
